// ***********************************************************
// pathname: /v1/user-phone/confirm
// ***********************************************************
import { useSwrMutationApi } from '@hooks/useSwrApi';
import { useTranslation } from 'next-i18next';

/** Props */
interface SwrUserPhoneConfirmProps {
  locale: string;
  successCallback?: () => void;
  errorCallback?: () => void;
}

/**
 * @description This hook is used for verifying the user's phone number.
 * - `locale` is the language locale
 * - `successCallback` is a function that is called when the request is successful
 * - `errorCallback` is a function that is called when the request fails
 */
export const useSwrUserPhoneConfirm = (props: SwrUserPhoneConfirmProps) => {
  // Destructure props
  const {
    locale,
    successCallback,
    errorCallback,
  } = props;

  // Translation
  const { t } = useTranslation('common');

  // Return hook
  return useSwrMutationApi<object, ApiSchema<'PhoneNumberClaimCodeWrite'>>({
    url: '/v1/user-phone/confirm',
    locale,
    fetcherConfig: {
      method: 'POST',
      stringifyPayload: true,
    },
    apiOptions: {
      onSuccess: () => {
        if (successCallback) successCallback();
      },
      onError: () => {
        if (errorCallback) errorCallback();
      },
    },
    toastsOptions: {
      showSuccessToast: true,
      successToastText: t('account-confirm-phone-number-succes'),
      showErrorToast: true,
      errorToastText: t('phone.number.confirm.failed'),
    },
  });
};
